module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-568-min.d6740e76.jpg";